import cloneDeep from "lodash.clonedeep";
import { actions } from "./actions";
import { DEFAULT_STATE } from "./state";
import { mutationTypes, getterTypes } from "./types";

export default {
    actions,
    mutations: {
        [mutationTypes.importLogGetDataStart](state) {
            state.isLoading = true;
            state.data = null;
        },
        [mutationTypes.importLogGetDataSuccess](state, data) {
            state.isLoading = false;
            // response body is { data: [...] }
            state.data = data.data || data;
        },
        [mutationTypes.importLogGetDataFailure](state) {
            state.isLoading = false;
        },
    },
    getters: {
        [getterTypes.getImportLogs](state) {
            return state.data;
        },
        [getterTypes.isLoading](state) {
            return state.isLoading;
        },
    },
    state: cloneDeep(DEFAULT_STATE),
};
